import { BaseTextMergeContainerElement } from "../BaseTextMergeContainerElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { BaseJSONXMLElement } from "./BaseJSONXMLElement";
import { DataUtilities } from "../../../Common/DataUtilities";
import { ExpressionValueType } from "../../../Expressions/ExpressionValueType";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

let _any: AppGlueAny;

export class XMLAttributeElement extends BaseTextMergeContainerElement {
    readonly __type: string = "xmlattribute";
    readonly name: string = "XML Attribute";
    readonly ordinal: number = 10;
    readonly styleElement: boolean = false;

    static outputXMLContainer(
        config: TextMergeConfiguration,
        element: BaseTextMergeContainerElement,
        elementName: string,
        data: ExecutionData,
        testContext?: ITestingContext,
    ): string {
        let fields = element.elements.filter((e) => {
            return e.__type !== "xmlattribute";
        });
        let attributes = element.elements.filter((e) => {
            return e.__type === "xmlattribute";
        });

        let s = "";

        s = s + DataUtilities.getIndent(element.getDepth()) + "<" + elementName;

        for (let e of attributes) {
            s = s + e.output(data, config, testContext);
        }

        s = s + ">\n";

        for (let e of fields) {
            s = s + e.output(data, config, testContext);
        }

        s = s + DataUtilities.getIndent(element.getDepth()) + "</" + elementName + ">\n";

        return s;
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return config.type === TextMergeType.XML;
    }

    getHTMLTag(): string {
        return "";
    }

    override output(
        data: ExecutionData,
        config: TextMergeConfiguration,
        testContext: ITestingContext | undefined,
    ): string {
        let output = " ";

        for (let e of this.elements) {
            let xe = e as BaseJSONXMLElement;

            let val = data.get(TextMergeConfiguration.DEFAULT_VALUE_DATA_NAME);
            if (xe.value.rootExpression.expressionRoot.valueType !== ExpressionValueType.UNSET) {
                try {
                    val = xe.value.run(data, testContext);
                } catch (e: AppGlueAny) {
                    if (e.message.indexOf("is missing") !== -1) val = "[Error: " + e.message + "]";
                }
            }

            if (xe) {
                output = output + " " + xe.fieldName + '="' + val + '"';
            }
        }

        return output;
    }
}
